// extracted by mini-css-extract-plugin
module.exports = {"container":"_3HRxrxO5082gd5fXEfTkCm","icon":"Aef64oY6OTZuOeJTTXVcZ"};